export const GET_DMX_COMPATIBLE_DEVICES = 'GET_DMX_COMPATIBLE_DEVICES';
export const GET_DMX_COMPATIBLE_DEVICES_SUCCESS = 'GET_DMX_COMPATIBLE_DEVICES_SUCCESS';
export const GET_DMX_COMPATIBLE_DEVICES_ERROR = 'GET_DMX_COMPATIBLE_DEVICES_ERROR';
